import { useRouter } from 'next/router';
import Link, { LinkProps } from 'next/link';
import { FC } from 'react';
import { UrlObject } from 'url';

interface LinkWithQueryProps extends LinkProps {
  href: string | UrlObject;
  queryParams?: string[];
  children: React.ReactNode;
  className?: string;
};

const LinkWithQuery: FC<LinkWithQueryProps> = ({ href, queryParams = [], children, className, ...props }) => {
  const router = useRouter();

  // فیلتر کردن کوئری‌های موردنظر از query فعلی
  const filteredQuery: Record<string, string> = {};
  queryParams.forEach(param => {
    if (router.query[param]) {
      filteredQuery[param] = router.query[param] as string;
    }
  });

  let newHref: UrlObject;

  if (typeof href === 'string') {
    const url = new URL(href, 'http://dummy-base'); // دامنه فیک برای پردازش URL
    const existingParams = new URLSearchParams(url.search);
    
    // اضافه کردن کوئری‌های فیلتر شده به کوئری‌های موجود
    Object.entries(filteredQuery).forEach(([key, value]) => {
      existingParams.set(key, value);
    });

    newHref = { pathname: url.pathname, query: Object.fromEntries(existingParams.entries()) };
  } else {
    newHref = { pathname: href.pathname, query: { ...(typeof href.query === "object" ? href.query : {}), ...filteredQuery } };
  }


  return (
    <Link href={newHref} className={className} {...props}>
      {children}
    </Link>
  );
};

export default LinkWithQuery;
